export enum InvoiceConfigSteps {
	FISCAL_DATA = "fiscalData",
	DIGITAL_CERTIFICATE = "digitalCertificate",
	TAXES = "taxesData",
	SUMMARY = "summary"
}
